var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffDarkGrey48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41463 19.6364C11.8932 19.6364 13.9024 21.59 13.9024 24C13.9024 26.41 11.8932 28.3636 9.41463 28.3636C6.93609 28.3636 4.92683 26.41 4.92683 24C4.92683 21.59 6.93609 19.6364 9.41463 19.6364ZM9.41463 20.364C7.34918 20.364 5.67516 21.9917 5.67516 24C5.67518 26.0083 7.34919 27.636 9.41463 27.636C11.4801 27.636 13.1541 26.0083 13.1541 24C13.1541 21.9917 11.4801 20.364 9.41463 20.364Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2439 20.7273C28.1028 20.7273 29.6098 22.1925 29.6098 24C29.6098 25.8075 28.1028 27.2727 26.2439 27.2727C24.385 27.2727 22.878 25.8075 22.878 24C22.878 22.1925 24.385 20.7273 26.2439 20.7273ZM26.2439 21.8182C25.0046 21.8182 24 22.795 24 24C24 25.205 25.0046 26.1818 26.2439 26.1818C27.4832 26.1818 28.4878 25.205 28.4878 24C28.4878 22.795 27.4832 21.8182 26.2439 21.8182Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2195 21.8182H31.2927V22.7269H35.2195V23.8178H31.2927V27.2727H30.1707V20.7273H35.2195V21.8182Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8293 21.8182H36.9024V22.7269H40.8293V23.8178H36.9024V27.2727H35.7805V20.7273H40.8293V21.8182Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8293 18C44.2373 18 47 20.6863 47 24C47 27.3137 44.2373 30 40.8293 30H7.17073C3.76273 30 1 27.3137 1 24C1 20.6863 3.76273 18 7.17073 18H40.8293ZM7.17073 19.0909C4.38237 19.0909 2.12195 21.2888 2.12195 24C2.12195 26.7112 4.38237 28.9091 7.17073 28.9091H40.8293C43.6176 28.9091 45.878 26.7112 45.878 24C45.878 21.2888 43.6176 19.0909 40.8293 19.0909H7.17073Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffDarkGrey48);
export default __webpack_public_path__ + "static/media/off_dark_grey48.ebd64ee87022271573e745c4a27c3f35.svg";
export { ForwardRef as ReactComponent };